module.exports = __webpack_public_path__ + "static/media/tutorial.6e6729b2.gif";